module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/flow_04-486a931aedd6ccfe3580fa0cb8a9e0ff.png";